export const tokenAddresses = {
  EUL: "0xa153Ad732F831a79b5575Fa02e793EC4E99181b0",
  eUSD: "0x0000000000000000000000000000000000000000",
  rEUL: "0xE08e1f00D388E201e48842E53fA96195568e6813",
  seUSD: "0x0000000000000000000000000000000000000000",
} as const
